import { useMemo } from 'react';
import { getBillClientServiceOptions } from '~/business-logic/billServiceSelector';
import { useLocaleKeys } from '~/i18n';
import { costDisplayTextsPath } from '~/models/service-cost/selectors';
import { billingPeriodTextsPath } from '~/utils/billing-period-text';
export const useAgreementServiceOptions = (param)=>{
    let { services, controlData, items } = param;
    const { t: costDisplayTexts } = useLocaleKeys(costDisplayTextsPath);
    const { t: billingTexts } = useLocaleKeys(billingPeriodTextsPath);
    return useMemo(()=>getBillClientServiceOptions({
            items,
            services,
            controlData,
            costDisplayTexts,
            periodTexts: billingTexts.periods
        }), [
        items,
        services,
        controlData
    ]);
};
